export default __webpack_public_path__ + "static/media/logo-binance-long.65b4ec45.svg";